const routes = {
    home: '/',
    workspace: '/create_portfolio',
    template: '/choose_template',
    notFound: '*',
}

export default routes
